export const SOCIAL_MEDIA = "Social Media";
export const E_COMMERCE = "eCommerce";
export const ADVERTISING = "Advertising";

